import React from 'react';
import { Star } from 'lucide-react';
/**
 * Trust band right under the hero — five-star rating + customer count on
 * the left, "as seen in" press logos on the right.  Conventional but
 * battle-tested pattern for wellness/info-product landing pages.
 */
export function SocialProof() {
  const publications = ['VOGUE', 'WELL+GOOD', 'GOOP', 'MINDBODYGREEN', 'FORBES'];
  return <section className="py-8 md:py-10 border-y border-ink/5 bg-cream" data-id="element-188">
      <div className="max-w-6xl mx-auto px-6 md:px-12 flex flex-col md:flex-row items-center justify-between gap-5 md:gap-8" data-id="element-189">
        <div className="flex items-center gap-3" data-id="element-190">
          <div className="flex" data-id="element-191">
            {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-sand text-sand" data-id="element-192" />)}
          </div>
          <span className="text-sm font-medium tracking-wide text-ink" data-id="element-193">
            +5,000 mujeres transformadas
          </span>
        </div>

        <div className="flex flex-wrap justify-center gap-x-5 gap-y-2 md:gap-x-10 opacity-40 grayscale" data-id="element-194">
          {publications.map(pub => <span key={pub} className="text-xs md:text-sm font-serif tracking-[0.2em] uppercase" data-id="element-195">
              {pub}
            </span>)}
        </div>
      </div>
    </section>;
}